import { useEffect, useState } from "react";

export function useTranslateInput(languagesData: any) {
  const [languages, setLanguages] = useState<any>(null);

  useEffect(() => {
    if (languagesData && Object.keys(languagesData).length > 0) {
      setLanguages(languagesData);
    }
  }, [languagesData]);

  return languages;
}
